module.exports = __webpack_public_path__ + "static/media/YagoMahugo.f2f62181.jpg";